import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";



class MetaDataClass extends Component {
    userData2;
    constructor(props) {
        super(props);


        this.state = {
            title: '',


        }



    }

    componentDidMount() {
        this.userData2 = JSON.parse(localStorage.getItem('user2'));




        if (localStorage.getItem('user2')) {
            this.setState({
                title: this.userData2.title

            })


        } else {

            this.setState({
                title: ''

            })

        }



    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem('user2', JSON.stringify(nextState));

    }


    render() {
        const {t} = this.props;
        return (
            <Helmet>
                <title>{t('seo.title')}</title>
                <meta name="robots" content="noindex, nofollow"/>
                <meta name="description" content={t('seo.description')} />
            </Helmet>
        )
    }
}

export default withTranslation()(MetaDataClass);